<template>
   

    <div class="content-wrap">
        <div class="search-wrap">
            <div class="row">
                <div class="col-md-4">
                    <div class="mb-3">
                        <ElLabel name="제목">
                            <template v-slot:end="slotProps">
                            <ElInput :id="slotProps.id" v-model="state.searchParams.title" @inputKeyupEnter="searchTitle"/>
                            </template>
                        </ElLabel>
                    </div>
                </div>                    
            </div>
        </div>
        <div class="search-detail-wrap"></div> 
        <div class="text-end py-2">
        <ElButton type="search" @buttonClick="searchTitle()">검색</ElButton>
        </div>
        
        <div class="d-flex justify-content-between">
            <div></div>
            <div class="table-btn-group">
            <!-- <ElButton type="share">공유하기</ElButton>
            <img src="/images/vr.png" alt=""> -->
            <ElButton type="excelDownload" @buttonClick="excelDown()">엑셀다운</ElButton>
            </div>
        </div>
        <div class="table-responsive table-list table-cf">
            <DataTable  
            :value="state.gridRowData"   
            selectionMode="single"
            paginator 
            :rows="20" 
            :rowsPerPageOptions="[10, 20, 50, 100,200]" 
            @rowSelect="onRowSelect"
            scrollable scrollHeight="500px"
            >
            <template #empty> <div class="center">데이터가 존재하지 않습니다.</div> </template>
            <Column>
                <template #header>
                    <ElCheckbox v-model="allCheck"/>
                </template>
                <template #body="{data}">
                    <ElCheckbox 
                    v-model="state.selectedRow" 
                    :value="data.nws_seq"
                    />
                </template>
                
            </Column>
            <Column v-for="notice of state.gridColumn" :key="notice" :field="notice.field" :header="notice.headerName" sortable :style="notice.style"></Column>
            </DataTable>
        </div>
    
        <div class="text-end py-3" v-show="canUpdate">
            <ElButton type="primary" @buttonClick="$router.push('/cf/MCF_NT_001')">등록</ElButton>
            <ElButton type="primary"  @buttonClick="deleteRow()">삭제</ElButton>
        </div>
    </div>
    <div><ExcelManage
      ref="excelManageRef"
      v-show="false">
     </ExcelManage>
     </div>
</template>
    
<script setup>   
import {reactive,onBeforeMount,ref,computed} from 'vue'
import ExcelManage    from '@/components/common/MCO_EX_001.vue'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import vueRouterCmn from '@/js/vueRouterCmn';
import { useUserStore } from '@/store/user'
const userStore = useUserStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { nwsList, nwsDelete } from '@/api/nws';
import common from '@/js/common';

const excelManageRef = ref()


const state = reactive({
    gridColumn : [
        { headerName: '제목' ,   field: "title" , style: { minWidth: "200px" }},
        { headerName: '등록자' , field: "reg_user_nm" , style: { minWidth: "80px" }},
        { headerName: '등록일' , field: "fmt_reg_dt" , style: { minWidth: "80px" }}
    ],
    gridRowData :[],
    selectedRow :[],
    searchParams : {
        title : '',
        page_count : 1,
        unit_count : 100000,
    }
})
const allCheck = computed({
    get(){
        return state.gridRowData.length === state.selectedRow.length;
    },
    set(newValue){
        state.selectedRow = newValue ? state.gridRowData.map((item)=>{return item.nws_seq}) : [];
    }
})

//수정권한으로 row클릭시 상세조회/수정페이지 이동 분기처리
const canUpdate = computed(()=>{
    return common.checkAccessAuth('M007M009M001')
})

onBeforeMount(async () => {
    await getDataList()
})


const getDataList = async () =>{
    try {
        setIsLoading(true)
        const res = await nwsList(state.searchParams)
        state.gridRowData = res.rtn
    } catch (err) {
        console.error('/nws/nwsList ERROR!! => ' + err)
        alert('api 에러 발생!!')
    } finally {
        setIsLoading(false)
    }
}

const searchTitle = async () =>{ 
    await getDataList()
}

const deleteRow = async ()=>{
if(confirm("선택하신 항목을 삭제 하시겠습니까?")==true) { 
    const nwsSeq =  state.selectedRow

    let selectRows = state.selectedRow

    if(selectRows && selectRows?.length > 0) {
        for(let rows of selectRows) {
            if(nwsSeq?.length > 0) {
                //선택한 행들에 대한 삭제 api 호출
                for(let item of nwsSeq){
                    let params = {
                        nws_seq   : item,
                        del_yn   : 'Y',
                        ss_user_id : userStore.user.employeeId
                    };
                    try {
                        setIsLoading(true)
                        const res = await nwsDelete(params)
                        await getDataList()
                    } catch (err) {
                        console.error('error', err)
                    } finally {
                        setIsLoading(false)
                    }
                }
            }
        }
        
        alert(selectRows.length + '건 삭제완료!!')
    } 
    else {
        alert('선택된 행이 없습니다.')
    }
}
}
//엑셀 다운로드
const excelDown = async () =>{
let fileNm = 'News&Notice 리스트'
let header = state.gridColumn
let dataList = state.gridRowData
if(state.selectedRow?.length > 0){
    let checkList = state.gridRowData.filter((item)=>{
    for(let i of state.selectedRow){
        if(i == item.nws_seq){
        return item
        }
    }
    })
    dataList = checkList
}

excelManageRef.value.excelDownload(fileNm,header,dataList)
}

const onRowSelect = (notice) =>{
    if(canUpdate.value){
        vueRouterCmn.routerPush('MCF_NT_001',{nws_seq : notice.data.nws_seq})
    }else{
        vueRouterCmn.routerPush('MCF_NT_003',{nws_seq : notice.data.nws_seq})
    }
}
</script>